module.exports = __webpack_public_path__ + "img/pcb_07.5f611da9.png";